import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function NoticeSubtract({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 18 18" width={size} {...props}>
      <Path
        d="M15 9H3"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      />
    </Svg>
  );
});
